import { nowUtcIso } from '@/lib/dates'
import { newUuid } from '@/offline/queue'
import type { Device, Sale } from '@/offline/types'

export interface SaleFormInput {
  workspace_id: string
  device: Device
  purchase_id: string
  sale_amount_paisa: number
  received_paisa: number
  customer_contact_id?: string | null
  customer_name?: string | null
  customer_phone?: string | null
  sold_at?: string
  notes?: string | null
}

export interface BuiltSale {
  sale: Sale
  deviceId: string
  payload: Record<string, unknown>
}

/**
 * Build the local sale record + server payload. The sale links to the purchase cycle
 * being sold (trade cycle), so profit and the double-sell lock key off purchase_id.
 */
export function buildSale(input: SaleFormInput): BuiltSale {
  const now = nowUtcIso()
  const sale: Sale = {
    workspace_id: input.workspace_id,
    id: newUuid(),
    device_id: input.device.id,
    purchase_id: input.purchase_id,
    sale_amount_paisa: input.sale_amount_paisa,
    received_paisa: input.received_paisa,
    customer_contact_id: input.customer_contact_id ?? null,
    customer_name: input.customer_name?.trim() ? input.customer_name.trim() : null,
    customer_phone: input.customer_phone?.trim() ? input.customer_phone.trim() : null,
    sold_at: input.sold_at ?? now,
    exchange_purchase_id: null,
    returned_at: null,
    notes: input.notes ?? null,
    revision: 1,
    created_at: now,
    updated_at: now,
    deleted_at: null,
  }
  const payload: Record<string, unknown> = {
    device_id: sale.device_id,
    purchase_id: sale.purchase_id,
    sale_amount_paisa: sale.sale_amount_paisa,
    received_paisa: sale.received_paisa,
    customer_contact_id: sale.customer_contact_id,
    customer_name: sale.customer_name,
    customer_phone: sale.customer_phone,
    sold_at: sale.sold_at,
    notes: sale.notes,
  }
  return { sale, deviceId: input.device.id, payload }
}
